import { Box, Text } from '@factorialco/deprecated-design-system'

export const LineItem = ({
  label,
  value,
  textAlign,
}: {
  label: string
  value: string | number | React.ReactNode
  textAlign: 'center' | 'left' | 'right'
}) => (
  <Box gap="s2" textAlign={textAlign}>
    <Text.Normal color="grey1000" weight="semibold" size="200">
      {label}
    </Text.Normal>
    <Text.Normal color="grey800" weight="medium" size="200">
      {value}
    </Text.Normal>
  </Box>
)
